import { useRef, useState } from "react";
import { faChartColumn } from "@fortawesome/free-solid-svg-icons";
import { CORAL, MUTED, NAVY } from "../constants";
import { exportPanelsSeparately } from "../exportUtils";
import { SectionTitle } from "./SectionTitle";
import { TwoPanelChartPanel } from "./TwoPanelChartPanel";

export function TwoPanelChartCard({ chart, isLoading, fallbackTitle, rulesKey }) {
  const sectionRef = useRef(null);
  const headerRef = useRef(null);
  const monthlyPanelRef = useRef(null);
  const quarterlyPanelRef = useRef(null);
  const [isExporting, setIsExporting] = useState(false);
  const handleExport = async () => {
    if (isLoading) return;
    setIsExporting(true);
    try {
      await exportPanelsSeparately(
        headerRef,
        [
          { ref: monthlyPanelRef, suffix: "_Monthly" },
          { ref: quarterlyPanelRef, suffix: "_By_Quarter" },
        ],
        chart?.title || fallbackTitle
      );
    } finally {
      setIsExporting(false);
    }
  };

  const series = Array.isArray(chart?.series) ? chart.series : [];
  const barSeries = series.find((s) => s.type === "bar");
  const lineSeries = series.find((s) => s.type === "line");

  return (
    <section ref={sectionRef} className="min-w-0 rounded-2xl border border-[#d6dfeb] bg-white shadow-sm overflow-hidden flex flex-col">
      <div className="px-4 pt-4" ref={headerRef}>
        <SectionTitle title={chart?.title || fallbackTitle} icon={faChartColumn} rulesKey={rulesKey} onExport={handleExport} isExporting={isExporting} disabled={isLoading} />
        {chart?.subtitle && (
          <p className="text-xs mt-1" style={{ color: MUTED }}>{chart.subtitle}</p>
        )}
        {(barSeries || lineSeries) && (
          <div className="flex items-center gap-4 mt-2">
            {barSeries && (
              <div className="flex items-center gap-1.5">
                <div className="w-3 h-3 rounded-sm" style={{ background: NAVY }} />
                <span className="text-[11px] font-semibold" style={{ color: NAVY }}>{barSeries.label}</span>
              </div>
            )}
            {lineSeries && (
              <div className="flex items-center gap-1.5">
                <div className="w-5 rounded" style={{ height: 2, background: CORAL }} />
                <span className="text-[11px] font-semibold" style={{ color: NAVY }}>{lineSeries.label}</span>
              </div>
            )}
          </div>
        )}
      </div>
      <div className="px-3 pt-3 pb-4">
        {isLoading ? (
          <div className="h-[320px] flex items-center justify-center text-sm" style={{ color: MUTED }}>Loading…</div>
        ) : (
          <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
            <div className="min-w-0 lg:col-span-2" ref={monthlyPanelRef}>
              <TwoPanelChartPanel panelTitle="Monthly — Full Year" panel={chart?.monthly} series={series} height={300} />
            </div>
            <div className="min-w-0" ref={quarterlyPanelRef}>
              <TwoPanelChartPanel panelTitle="By Quarter" panel={chart?.quarterly} series={series} height={300} />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
